import css from 'styled-jsx/css';

const styles = css`
  .filter-sub-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 12px 16px;
  }
  .filter-sub-title {
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    margin: 0;
  }
`;

export default styles;
